<template>
    <div class="categories-component">
        <TypographyIcon :hasText="true" @click="toggleTypography" :selected="typographySelected" />
        <AlbumArtworkIcon :hasText="true" @click="toggleAlbumArtwork" :selected="albumArtworkSelected" />
        <ThreeDimensionalWorksIcon :hasText="true" @click="toggleThreeDimensional"
            :selected="threeDimensionalSelected" />
        <SoundDesignIcon :hasText="true" @click="toggleSoundDesign" :selected="soundDesignSelected" />
        <OtherWorksIcon :hasText="true" @click="toggleOtherWorks" :selected="otherWorksSelected" />
    </div>
</template>

<style scoped>
.categories-component {
    display: flex;
    flex-direction: row;
    gap: 35px;
    width: 908px;
    height: 57px;
}

.categories-component :deep(.navbar-text-desc) {
    font-size: 15px;
    min-height: 36px;
    letter-spacing: var(--action-letter-spacing);
    padding: 13.5px 0;
    line-height: 18px;
}

.categories-component :deep(.category-icon) {
    cursor: pointer;
    align-items: center;
}

.categories-component :deep(.category-icon) p {
    min-height: 36px;
}

@media (max-width: 1260px) {
    .categories-component {
        width: 579px;
        height: 44px;
    }

    .categories-component :deep(.category-icon) {
        align-items: center;
    }

    .categories-component :deep(.category-icon) svg {
        width: 44px;
    }

    .categories-component :deep(.navbar-text-desc) p {
        font-size: 11.81px;
        line-height: 14px;
        min-height: 28px;
    }
}

@media (max-width: 996px) {
    .categories-component {
        width: 100%;
        margin: 0 auto;
    }

    .categories-component :deep(.category-icon) {
        width: 100%;
        margin-right: 7%;
    }
}

@media (max-width: 935px) {
    .categories-component {
        width: 100%;
        margin: 0 auto;
    }

    .categories-component :deep(.category-icon) {
        width: 100%;
        margin-right: 6.8%;
    }
}

@media (max-width: 920px) {
    .categories-component {
        width: 100%;
        margin: 0 auto;
    }

    .categories-component :deep(.category-icon) {
        width: 100%;
        margin-right: 6.4%;
    }
}

@media (max-width: 890px) {
    .categories-component {
        width: 100%;
        margin: 0 auto;
    }

    .categories-component :deep(.category-icon) {
        width: 100%;
        margin-right: 5.7%;
    }
}

@media (max-width: 890px) {
    .categories-component {
        width: 100%;
        margin: 0 auto;
    }

    .categories-component :deep(.category-icon) {
        width: 100%;
        margin-right: 4.9%;
    }
}

@media (max-width: 830px) {
    .categories-component {
        width: 100%;
        margin: 0 auto;
    }

    .categories-component :deep(.category-icon) {
        width: 100%;
        margin-right: 4%;
    }
}

@media (max-width: 800px) {
    .categories-component {
        width: 100%;
        margin: 0 auto;
    }

    .categories-component :deep(.category-icon) {
        width: 100%;
        margin-right: 3.1%;
    }
}

@media (max-width: 765px) {
    .categories-component {
        width: 100%;
        margin: 0 auto;
    }

    .categories-component :deep(.category-icon) {
        width: 100%;
        margin-right: 2.1%;
    }
}

@media (max-width: 740px) {
    .categories-component {
        height: 28px;
    }

    .categories-component :deep(.category-icon) {
        align-items: center;  
        margin-right: 8%;   
    }

    .categories-component :deep(.category-icon) svg {
        width: 28px;
    }

    .categories-component :deep(.navbar-text-desc) p {
        font-size: 7.5px;
        line-height: 10px;
        max-width: 20px;
        min-height: 20px;
    }
}

@media (max-width: 700px) {
    .categories-component {
        width: 100%;
        margin: 0 auto;
    }

    .categories-component :deep(.category-icon) {
        width: 100%;
        margin-right: 6.4%;
    }
}

@media (max-width: 700px) {
    .categories-component {
        width: 100%;
        margin: 0 auto;
    }

    .categories-component :deep(.category-icon) {
        width: 100%;
    }
}

@media (max-width: 640px) {
    .categories-component {
        width: 100%;
        margin: 0 auto;
    }

    .categories-component :deep(.category-icon) {
        width: 100%;
        margin-right: 4.8%;
    }
}

@media (max-width: 595px) {
    .categories-component {
        width: 100%;
        margin: 0 auto;
    }

    .categories-component :deep(.category-icon) {
        width: 100%;
        margin-right: 3.1%;
    }
}

@media (max-width: 560px) {
    .categories-component {
        width: 100%;
        margin: 0 auto;
    }

    .categories-component :deep(.category-icon) {
        width: 100%;
        margin-right: 1.5%;
    }
}

@media (max-width: 530px) {
    .categories-component {
        width: 100%;
        margin: 0 auto;
    }

    .categories-component :deep(.category-icon) {
        width: 100%;
        margin-right: 0;
    }
}

@media (max-width: 480px) {
    .categories-component {
        gap: 0;
        justify-content: space-between;
    }

    .categories-component :deep(.category-icon) {
        width: fit-content;
    }
}

@media (max-width: 390px) {
    .categories-component :deep(.category-icon) {
        gap: 10px;
    }
}

</style>

<script setup>
import { ref } from 'vue';
import TypographyIcon from '../atoms/typography-icon.vue';
import SoundDesignIcon from '../atoms/sound-design-icon.vue';
import AlbumArtworkIcon from '../atoms/album-artwork-icon.vue';
import ThreeDimensionalWorksIcon from '../atoms/three-dimensional-works-icon.vue';
import OtherWorksIcon from '../atoms/other-works-icon.vue';

const typographySelected = ref(false);
const soundDesignSelected = ref(false);
const albumArtworkSelected = ref(false);
const threeDimensionalSelected = ref(false);
const otherWorksSelected = ref(false);

const selectedCategories = defineModel()

function updateSelection() {
    const typo = typographySelected.value ? 'typography' : null
    const albumArt = albumArtworkSelected.value ? 'album_art' : null
    const threeDim = threeDimensionalSelected.value ? 'three_d' : null
    const soundDesign = soundDesignSelected.value ? 'sound_design' : null
    const other = otherWorksSelected.value ? 'other' : null
    selectedCategories.value = [typo, albumArt, threeDim, soundDesign, other].filter(item => item !== null)
}

function toggleTypography() {
    typographySelected.value = !typographySelected.value;
    updateSelection()
}

function toggleSoundDesign() {
    soundDesignSelected.value = !soundDesignSelected.value;
    updateSelection()
}

function toggleAlbumArtwork() {
    albumArtworkSelected.value = !albumArtworkSelected.value;
    updateSelection()
}

function toggleThreeDimensional() {
    threeDimensionalSelected.value = !threeDimensionalSelected.value;
    updateSelection()
}

function toggleOtherWorks() {
    otherWorksSelected.value = !otherWorksSelected.value;
    updateSelection()
}
</script>